import * as openpgp from "openpgp";
import { clearContentKeys, setContentKeys } from "./contentKeys";

// Klucze prywatni FIRMY (poziom 2 hierarchii, docs/model-kluczy-firmowych.md) — cienka
// nakładka na slot 'company' mirrora kluczy treści (utils/contentKeys.ts).
//
// DAWNIEJ (F3) ten slot był UNIĄ dwóch pokoleń materiału — kluczy firmy i starych kluczy
// PROFILI, bo dane sprzed przełączenia zapisu na klucz firmy trzeba było dalej czytać.
// Po F4 (purge treści starego modelu) i F5 (DROP profili) ta druga połowa jest trwale
// pusta — nie ma już ani jednego wiersza zaszyfrowanego wprost kluczem profilu — więc
// moduł wraca do jednego źródła.

let companyKeys: openpgp.key.Key[] = [];

// Słuchacze zmiany materiału firmy. Klucze prywatne firmy dojeżdżają asynchronicznie
// (App.tsx: granty → odszyfrowanie), zwykle PO tym, jak PluginContext połączył wtyczkę —
// ta dostaje wtedy klucz intermediate i nie otworzy żadnego dokumentu (klucze teczek są
// owinięte kluczem firmy). PluginContext nasłuchuje tu i łączy się ponownie.
type Listener = () => void;
const listeners = new Set<Listener>();

/** Subskrypcja zmiany kluczy prywatnych firmy; zwraca funkcję wypisania. */
export const onCompanyPrivateKeysChanged = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const notify = () => listeners.forEach((l) => l());

/**
 * Klucze prywatne FIRMY (wszystkie generacje, na które zalogowany ma grant).
 * Wołane raz na sesję po odszyfrowaniu grantów.
 */
export const setCompanyPrivateKeys = (
  keys: openpgp.key.Key[] | null | undefined,
): void => {
  companyKeys = keys ?? [];
  setContentKeys("company", companyKeys);
  notify();
};

/** Czyści slot 'company' — wylogowanie / zmiana firmy. */
export const clearCompanyContentKeys = (): void => {
  companyKeys = [];
  clearContentKeys("company");
  notify();
};

/** Klucze prywatne firmy (diagnostyka i bramki „czy mam klucz firmy"). */
export const getCompanyPrivateKeys = (): openpgp.key.Key[] => [...companyKeys];

/** Czy sesja ma choć jeden klucz prywatny firmy (grant został wydany i rozpakowany). */
export const hasCompanyPrivateKeys = (): boolean => companyKeys.length > 0;
